import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';

export const SummaryCardBody = styled.div`
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  padding: 1rem 0px;
  > div:not(:last-child) {
    margin-bottom: 10px;
  }
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    padding: 1rem 0px 0px;
  }
`;

export const SummaryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  p:last-child {
    font-weight: 500;
  }
`;
